import { __ } from '@wordpress/i18n'
import { 
	Fragment,
} from '@wordpress/element'

import { 
	ServerSideRender, PanelBody, ToggleControl, SelectControl, TextareaControl, TextControl
} from '@wordpress/components'
import { 
	DesignPanelBody, PostIDSelector, ImageControl
} from '~cartzillagb/components'
import { 
	 isMasStaticActive, wpRegisteredSidebars, i18n , themeAssetsURL
} from 'cartzillagb'
import ImageDesignBasic from './images/basic.png'
import ImageDesignPlain from './images/plain.png'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import {
	withTabbedInspector
} from '~cartzillagb/higher-order'
import { 
	withSelect 
} from '@wordpress/data'
import classnames from 'classnames'



addFilter( 'cartzillagb.footer.edit.inspector.style.before', 'cartzillagb/footer', ( output, props ) => {
	const { attributes, setAttributes, menuOptions, className } = props
	const {
		design,
		footerType,
		footerStaticContentId,
		enableFooterWidgets,
		footerWidgetColumn1,
		footerWidgetColumn2,
		footerWidgetColumn3,
		enableFooterStaticContent,
		enableFooterMenu,
		enableFooterSocialMenu,
		enableFooterPayment,
		enableFooterCopyright,
		copyrightText,
		copyrightAlignment,
		logoImageID ,
        logoImageUrl,
        footerPrimaryMenuSlug,
        enableLogoTitle,
        additionalClass,
        logoImageID1,
        logoImageUrl1,
        enableLanguageCurrency,
        enableFooterStatistics,
        footerSiteTitle,
		footerSiteDesc

	} = attributes

	const allSidebars = JSON.parse( wpRegisteredSidebars )
    let sidebarOptions = []

    sidebarOptions = Object.keys( allSidebars ).map( ( key ) => ( {
        label: allSidebars[key].name,
        value: allSidebars[key].id
    } ) )

    sidebarOptions.unshift( {
        label: __( 'None' ),
        value: ''
    } )

	return (
		<Fragment>
			<DesignPanelBody
				initialOpen={ true }
				selected={ design }
				options={ applyFilters( 'cartzillagb.footer.edit.layouts', [
					{
						 label: __( 'Footer v1', i18n ), value: 'v1', image: ImageDesignBasic,
					},
					{
						label: __( 'Footer v2', i18n ), value: 'v2', image: ImageDesignPlain,
					},
					{
						label: __( 'Footer v3', i18n ), value: 'v3', image: ImageDesignBasic,
					},
				  ] ) }
				 onChange={ design => setAttributes( { design } ) }
			  >
			 </DesignPanelBody>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<Fragment>
					<SelectControl
						label={ __( 'Footer Type', i18n ) }
						values={ footerType }
						options={ [
							{ label: __('Dark', 'cartzilla', i18n ), value: 'dark' },
							{ label: __('Light', 'cartzilla', i18n ), value: 'light' },
						] }
						onChange={ footerType => setAttributes( { footerType } ) }
					/>

					{ ( design === 'v1' || design === 'v2' ) && 
						<ToggleControl
							label={ __( 'Enable Language Currency', i18n ) }
							checked={ enableLanguageCurrency }
							onChange={ enableLanguageCurrency => setAttributes( { enableLanguageCurrency } ) }
						/>
					}

					{ design === 'v3' &&
						<Fragment>
							<TextControl
				                label={ __( 'Footer Site Title', i18n ) }
				                value={ footerSiteTitle }
				                onChange={ ( footerSiteTitle ) => setAttributes( { footerSiteTitle } ) }
				            />
				            <TextareaControl
								label={ __( 'Footer Site Description', i18n ) }
								value={ footerSiteDesc }
								placeholder={ __( 'High quality items created by our global community.', i18n ) }
								onChange={ footerSiteDesc  => setAttributes( { footerSiteDesc } ) }
							/>
							<ToggleControl
								label={ __( 'Show Footer Statistics?', i18n ) }
								checked={ enableFooterStatistics }
								onChange={ enableFooterStatistics => setAttributes( { enableFooterStatistics } ) }
							/>
						</Fragment>
					}

					<ToggleControl
						label={ __( 'Enable Footer Widgets', i18n ) }
						checked={ enableFooterWidgets }
						onChange={ enableFooterWidgets => setAttributes( { enableFooterWidgets } ) }
					/>

					{ ( design === 'v1' || design === 'v3' ) && 
						<Fragment>
							<ToggleControl
								label={ __( 'Enable Footer Static Content', i18n ) }
								checked={ enableFooterStaticContent }
								onChange={ enableFooterStaticContent => setAttributes( { enableFooterStaticContent } ) }
							/>

							<ToggleControl
								label={ __( 'Enable Footer Quick Link Menu', i18n ) }
								checked={ enableFooterMenu }
								onChange={ enableFooterMenu => setAttributes( { enableFooterMenu } ) }
							/>

							<ToggleControl
								label={ __( 'Enable Footer Social Menu', i18n ) }
								checked={ enableFooterSocialMenu }
								onChange={ enableFooterSocialMenu => setAttributes( { enableFooterSocialMenu } ) }
							/>
						</Fragment>
					}

					{ ( design === 'v1' || design === 'v2' ) && 
						<Fragment>
							

							{ enableFooterPayment && 
								<ImageControl
				                    label={ __( 'Upload Payment Image' , i18n) }
				                    onRemove={ media => {
				                        setAttributes( { logoImageID1: 0 } )
				                        setAttributes( { logoImageUrl1: '' } )
				                    } }
				                    onChange={ media => {
				                        setAttributes( { logoImageID1: media.id } )
				                        setAttributes( { logoImageUrl1: media.url } )
				                    } }
				                    render={ <img src={ logoImageUrl1 } alt={ __( 'Payment' ) }/> }
				                    imageID={ logoImageID1 }
				                    imageURL={ logoImageUrl1 }
				                    allowedTypes={ [ 'image' ] }

				                />
							}
						</Fragment>
					}

				</Fragment>
			</PanelBody>

			<PanelBody title={ __( "Logo Settings", i18n ) } initialOpen={ false }>
				<Fragment>
					<ToggleControl
						label={ __( 'Enable Logo Site Title', i18n ) }
						checked={ enableLogoTitle }
						onChange={ enableLogoTitle => setAttributes( { enableLogoTitle } ) }
					/>
		
					<ImageControl
	                    label={ __( 'Upload logo', i18n ) }
	                    onRemove={ media => {
	                        setAttributes( { logoImageID: 0 } )
	                        setAttributes( { logoImageUrl: '' } )
	                    } }
	                    onChange={ media => {
	                        setAttributes( { logoImageID: media.id } )
	                        setAttributes( { logoImageUrl: media.url } )
	                    } }
	                    render={ <img src={ `${ themeAssetsURL }img/footer-logo-dark.png` } alt={ __( 'logo' ) }/> }
	                    imageID={ logoImageID }
	                    imageURL={ logoImageUrl }
	                    allowedTypes={ [ 'image' ] }

	                />
		            
                </Fragment>
			</PanelBody>
			{ ( enableFooterMenu && ( design === 'v1' || design === 'v3' ) ) &&
				<PanelBody title={ __( "Menu Settings", i18n ) } initialOpen={ false }>
					<SelectControl
	                    label={ __( 'Select a footer menu', i18n ) }
	                    options={ menuOptions }
	                    value={ footerPrimaryMenuSlug }
	                    onChange={ footerPrimaryMenuSlug => setAttributes( { footerPrimaryMenuSlug } ) }
	                />
	             </PanelBody>
	         }


			{ ( isMasStaticActive && enableFooterStaticContent && ( design === 'v1' || design === 'v3' ) ) &&
				<PanelBody title={ __( 'Footer Jumbotron' ) } initialOpen={ false }>
                    <PostIDSelector
                        onPostSelect={ footerStaticContentId => {
                            setAttributes( { footerStaticContentId } )
                        } }
                        posts={ footerStaticContentId ? [ footerStaticContentId ] : [] }
                        onChange={ footerStaticContentIds => {
                            if( footerStaticContentIds && footerStaticContentIds.length ) {
                                setAttributes( { footerStaticContentId: footerStaticContentIds[0] } )
                            } else {
                                setAttributes( { footerStaticContentId: 0 } )
                            }
                        } }
                        postType="mas_static_content"
                        limit="1"
                     />
                </PanelBody>
			}

			{ enableFooterWidgets && 
				<PanelBody title={ __( 'Footer Widgets' ) } initialOpen={ false }>
	                <SelectControl
	                    label={ __( 'Footer Column 1', i18n ) }
	                    options={ sidebarOptions }
	                    value={ footerWidgetColumn1 }
	                    onChange={ ( footerWidgetColumn1 ) => setAttributes( { footerWidgetColumn1 } ) }
	                />
	                <SelectControl
	                    label={ __( 'Footer Column 2', i18n ) }
	                    options={ sidebarOptions }
	                    value={ footerWidgetColumn2 }
	                    onChange={ ( footerWidgetColumn2 ) => setAttributes( { footerWidgetColumn2 } ) }
	                />
	                { design !== 'v3' &&
	                <SelectControl
	                    label={ __( 'Footer Column 3', i18n ) }
	                    options={ sidebarOptions }
	                    value={ footerWidgetColumn3 }
	                    onChange={ ( footerWidgetColumn3 ) => setAttributes( { footerWidgetColumn3 } ) }
	                />
	                }
	             
	            </PanelBody>
	        }
	        <PanelBody title={ __( 'Footer Copyright Settings' ) } initialOpen={ false }>
		        <Fragment>
			        <ToggleControl
						label={ __( 'Enable Footer Copyright', i18n ) }
						checked={ enableFooterCopyright }
						onChange={ enableFooterCopyright => setAttributes( { enableFooterCopyright } ) }
					/>
					{ enableFooterCopyright && 
						<TextareaControl
							label={ __( 'Copyright Text', i18n ) }
							value={ copyrightText }
							placeholder={ __( '&copy; All rights reserved. Made by <a href="https://createx.studio/" target="_blank" rel="noopener noreferrer">Createx Studio</a>', i18n ) }
							onChange={ copyrightText  => setAttributes( { copyrightText } ) }
						/>
					}

					{ ( enableFooterCopyright &&  design === 'v1' ) && 
						<SelectControl
							label={ __( 'Copyright Alignment', i18n ) }
							values={ copyrightAlignment }
							options={ [
								{ label: __('Left', 'cartzilla', i18n ), value: 'left' },
								{ label: __('Center', 'cartzilla', i18n ), value: 'center' },
							] }
							onChange={ copyrightAlignment => setAttributes( { copyrightAlignment } ) }
						/>
					}
				</Fragment>
			</PanelBody>

			<PanelBody title={ __( 'Footer Bottom Bar Css Class Settings' ) } initialOpen={ false }>
				<TextControl
	                label={ __( 'Enter Class', i18n ) }
	                value={ additionalClass }
	                onChange={ ( additionalClass ) => setAttributes( { additionalClass } ) }
	            />
			</PanelBody>

		</Fragment>

		
	)
} )

const edit = props => {

	return (
		<ServerSideRender
			block="czgb/footer"
			attributes={ props.attributes }
		/>
	)
}

export default compose(
	
	withSelect( select => {
		const { getEntityRecords } = select( 'core' )
	    const menusList = getEntityRecords( 'taxonomy', 'nav_menu', { 'hide_empty': false, 'orderby': 'name', 'per_page': -1 } )

	    let menuOptions = [];

	    if( menusList && menusList.length > 0 ) {
	        menuOptions = menusList.map( ( menu ) => ( {
	            label: menu.name,
	            value: menu.slug
	        } ) )
	    }

	    menuOptions.unshift({
	        label: __( 'Default' ),
	        value: 0
	    })

	    return {
	        menuOptions: menuOptions,
	    }
	}),
	withTabbedInspector( [ 'style', 'advanced' ] ),

	
)( edit )

